import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';


export const fetchBackOrdersByInvoice = (invoice) => apiActionCreator({
  'endpoint': `/backorders/${invoice}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_BACK_ORDERS,
    ActionTypes.FETCHED_BACK_ORDERS,
    [
      ActionTypes.FETCHED_BACK_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadBackOrdersByInvoice = (invoice) => apiActionCreator({
  'endpoint': `/backorders/${invoice}/excel`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOADING_BACK_ORDERS,
    ActionTypes.DOWNLOADED_BACK_ORDERS,
    [
      ActionTypes.DOWNLOADED_BACK_ORDERS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const changeBackOrdersListPage = (value) => ({
  'type': ActionTypes.CHANGE_BACK_ORDERS_LIST_PAGE,
  'payload': value,
});

export const changeBackOrdersListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_BACK_ORDERS_LIST_PAGE_SIZE,
  'payload': value,
});

export const clearBackOrdersList = () => ({
  'type': ActionTypes.CLEAR_BACK_ORDERS_LIST,
});

export const changeBoxTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_BOX_TEXT_FILTER,
  'payload': value,
});

export const changePartCodeTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_PART_CODE_TEXT_FILTER,
  'payload': value,
});

export const changeInvoiceQuantityTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_INVOICE_QUANTITY_TEXT_FILTER,
  'payload': value,
});

export const changeInvoiceBackOrdersTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_INVOICE_BACK_ORDERS_TEXT_FILTER,
  'payload': value,
});

export const changeNationalBackOrdersTextFilter = (value) => ({
  'type': ActionTypes.CHANGE_NATIONAL_BACK_ORDERS_TEXT_FILTER,
  'payload': value,
});

export const changeRequester1TextFilter = (value) => ({
  'type': ActionTypes.CHANGE_REQUESTER_1_TEXT_FILTER,
  'payload': value,
});

export const changeRequester2TextFilter = (value) => ({
  'type': ActionTypes.CHANGE_REQUESTER_2_TEXT_FILTER,
  'payload': value,
});

export const changeRequester3TextFilter = (value) => ({
  'type': ActionTypes.CHANGE_REQUESTER_3_TEXT_FILTER,
  'payload': value,
});

export const clearTextFilter = () => ({
  'type': ActionTypes.CLEAR_TEXT_FILTER,
});

export const clearUrlBackOrders = () => ({
  'type': ActionTypes.CLEAR_URL_BACK_ORDERS,
});
